/*******************************************************************************************************
 **                                                                                                    **
 **                                             VARIABLES                                              **
 **                                                                                                    **
 *******************************************************************************************************/

const addToCartButtonLibrary = document.querySelector(".add-to-cart");
const addToCartForUnpaintedLibrary = document.querySelector(
	".add-to-cart-for-unpainted",
);
const addToCartStickyLibrary = document.querySelector(".sticky-add-to-cart");
// const checkboxGetPaintCodeWithVINAndLabel = document.querySelector('input#checkbox-get-paint-code-with-vin')?.closest('label');
// const checkboxGetPaintCodeWithLicenseAndLabel = document.querySelector('input#checkbox-get-paint-code-with-license')?.closest('label');
const colorPreviewContainerLibrary = document.querySelector(
	".color-preview-container-for-customizations",
);
const combinedVariantSelectLibrary =
	document.getElementById("variant-selector");
const fitmentDescriptionContainerLibrary = document.querySelector(
	".fitment-description-container",
);
const form = document.getElementById("product-form");
const getPaintCodeUsingVinLibrary = document.querySelector(
	".get-paint-code-using-vin",
);
const howToFindPaintCodeBtnLibrary = document.getElementById(
	"how-to-find-your-paint-code-vindecoder",
);
// const notCompatibleMsgLibrary = document.querySelector('.not-compatible-msg');
// const oemVinContainerLibrary = document.querySelector('.oem-vin-container');
const paintedStockKeyPaintLevelLibrary = document.querySelector(
	".painted-stock-key-paint-level",
);
const paintedStockKeyQualityLevelLibrary = document.querySelector(
	".painted-stock-key-quality-level",
);
const paintCodeAppContainerLibrary = document.getElementById(
	"paintcode-app-container",
);
const paintCodeAppContainerLicenseLibrary = document.getElementById(
	"paintcode-app-container-license",
);
const paintCodeWrapperLibrary = document.querySelector(".paint-code-wrapper");
const paintOptionCheckboxByPaintCode = document.getElementById(
	"checkbox-select-paint-option",
);
const paintOptionCheckboxByUnpainted = document.getElementById(
	"checkbox-select-unpainted",
);
// const paintOptionCheckboxByVIN = document.getElementById('checkbox-get-paint-code-with-vin');
// const paintOptionCheckboxByLicense = document.getElementById('checkbox-get-paint-code-with-license');
const paintOptionsCheckboxGroupLibrary = document.querySelector(
	".paint-options-checkbox-group",
);
const precisionMatchContainerLibrary = document.querySelector(
	".precision-match-container",
);
const precisionMatchCheckboxYes = document.getElementById("precision-match");
const precisionMatchLabelOptional = document.getElementById(
	"precision-match-label-optional",
);
const precisionMatchLabelRequired = document.getElementById(
	"precision-match-label-required",
);
const precisionMatchCheckboxNo = document.getElementById("standard-match");
const precisionMatchButton = document.getElementById("precision-match-button");
const precisionMatchInputBox = document.getElementById(
	"precision-match-textbox",
);
// const precisionMatchVinWrapper = document.getElementById(
// 	"precision-match-textbox-wrapper"
// );
// const precisionMatchWrapper = document.querySelector(
// 	".product-page-precision-match-wrapper"
// );
const priceContainerLargeScreen = document.querySelector(
	".price-container-large-screen",
);
const priceContainerSmallScreen = document.querySelector(".price-container");
const priceDisplay = document.getElementById("price-display");
const productPartDescriptionLibrary = document.querySelector(
	".product-description-collapsible-text",
);
const qualityTypeSelectLibrary = document.getElementById("quality-type-select");
const qualityOptionsCheckboxLibrary = document.querySelectorAll(
	".quality-options-checkbox",
);
const qualityDescriptionBtnLibrary = document.getElementById(
	"quality-description-vindecoder",
);
const selectVinVariantButtonLibrary =
	document.getElementById("select-vin-variant");
const titleElementLibrary = document.querySelector(".product-title");
// const vinTextBoxOEMLibrary = document.getElementById('vin-textbox-for-oem');
const vinVerificationCheckboxGroupLibrary = document.querySelector(
	".vin-verification-checkbox-group",
);
const vinVerifyCheckbboxYesLibrary = document.getElementById("fitment-yes");
const vinVerifyCheckboxNoLibrary = document.getElementById("fitment-no");
const vinVerificationButtonLibrary = document.getElementById(
	"vin-verification-button",
);
const vinVerificationWrapper = document.getElementById(
	"vin-textbox-for-verification-wrapper show",
);
const vinVerificationInput = document.getElementById(
	"vin-textbox-for-verification",
);

const vinAfterSelection = document.getElementById(
	"vin-after-paint-code-selection",
);

let emptyVinVerificationRadioButtons = true;
let emptyPrecisionMatchRadioButtons = true;
let boolMatchByVIN = false;
let selectedOptionHasAvailableStock = false;
let failedVinDecode = false;
let vinDecoderJustUsed = false;
// isVinDecoderExhausted: This is used to determine if the VIN decoder has been exhausted, meaning no more attempts can be made.
let isVinDecoderExhausted = false;
let isLicenseDecoderExhausted = false;
let addedBadgeInPaintOptions = false;
let selectedVariantUnavailable = false;
let typingVinPrecisionMatch = false;
let matchingByVin = false;
let aftermarketAvailability = "";
let capaAvailability = "";
let oemAvailability = "";
let storedVin = "";
let selectedProductSku = "";
let selectedProductColor = "";
let selectedProductTitle = "";
let selectedProductType = "";
let productVariants = {};
let fitmentQuestionScrollPosition = {};
let amountOfVINPostMessages = 0;
let amountOfOOSPaintVariants = 0;
let currentAddToCartBtnLibrary;
let isOnlyOEM = false;
if (addToCartButtonLibrary) {
	currentAddToCartBtnLibrary = addToCartButtonLibrary;
}
if (addToCartForUnpaintedLibrary) {
	currentAddToCartBtnLibrary = addToCartForUnpaintedLibrary;
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                             ENABLE/DISABLE                                         **
 **                                                                                                    **
 *******************************************************************************************************/
// Toggling

// DISABLING AND CLEARING
function hideFitmentFailButton() {
	// Must defined the element here as it is dynamically created
	const fitmentFailButtonLibrary = document.getElementById(
		"fitment-fail-button",
	);

	if (fitmentFailButtonLibrary) fitmentFailButtonLibrary.style.display = "none";
}

function clearQualityTypeSelect() {
	if (qualityOptionsCheckboxLibrary) {
		const qualityRadioButtons = document.querySelectorAll(
			'input[name="quality_type"]',
		);
		qualityRadioButtons.forEach((radio) => (radio.checked = false));
	} else {
		if (qualityTypeSelectLibrary) qualityTypeSelectLibrary.selectedIndex = 0;
	}
}

function disablePrePaintedMessagingQualityLevel() {
	if (paintedStockKeyQualityLevelLibrary) {
		paintedStockKeyQualityLevelLibrary.classList.add("disabled");
	}
}

function disableFitmentSelect() {
	const additionalOptionsTitle = document.querySelector(
		".additional-options-title",
	);
	const fitmentRadioButtons = document.querySelectorAll(".fitment-radio");
	const fitmentDescriptionContainer = document.querySelector(
		".fitment-description-container",
	);
	if (fitmentRadioButtons.length > 0) {
		fitmentRadioButtons.forEach((radio) => {
			if (radio) {
				radio.disabled = true;
				radio.checked = false;
			}
		});
	}
	const fitmentTexts = document.querySelectorAll(".fitmentText");
	if (fitmentTexts.length > 0) {
		fitmentTexts.forEach(function (el) {
			if (el) {
				el.classList.add("fitment-disabled");
				el.style.color = "#ccc";
			}
		});
	}
	const fitmentTypeSelects = document.querySelectorAll(".fitment-type-select");
	if (fitmentTypeSelects.length > 0) {
		fitmentTypeSelects.forEach(function (el) {
			if (el) {
				el.classList.add("fitment-disabled");
			}
		});
	}
	if (additionalOptionsTitle) {
		additionalOptionsTitle.classList.add("additional-options-title-disabled");
		additionalOptionsTitle.style.color = "#ccc";
	}
	// Disable the nearest button to fitmentDescriptionContainer
	if (fitmentDescriptionContainer) {
		const nearestButton =
			fitmentDescriptionContainer.querySelector("button") ||
			fitmentDescriptionContainer.closest("button") ||
			fitmentDescriptionContainer.parentElement.querySelector("button");
		if (nearestButton) {
			nearestButton.disabled = true;
		}
	}

	if (fitmentDescriptionContainerLibrary) {
		const firstFitmentQuestionButton = document.getElementById(
			"fitment-button-description-0",
		);
		if (firstFitmentQuestionButton) {
			firstFitmentQuestionButton.disabled = true;
		}
	}
}

function hideNotCompatibleMsg() {
	const notCompatibleMsgLibrary = document.querySelector(".not-compatible-msg");
	if (notCompatibleMsgLibrary) notCompatibleMsgLibrary.style.display = "none";
}

function disableQualityTypeSelect() {
	if (qualityOptionsCheckboxLibrary) {
		const qualityRadioButtons = document.querySelectorAll(
			'input[name="quality_type"]',
		);

		// If quality options checkboxes
		qualityRadioButtons.forEach((radio) => {
			radio.disabled = true;
		});
	}

	// If quality select dropdown
	clearQualityTypeSelect();
	if (qualityTypeSelectLibrary) qualityTypeSelectLibrary.disabled = true;
}

function disableQualityDescriptionBtn() {
	if (qualityDescriptionBtnLibrary)
		qualityDescriptionBtnLibrary.disabled = true;
}

// function disableVINTextboxForOEM() {
//     if (vinTextBoxOEMLibrary) {
//         vinTextBoxOEMLibrary.value = "";
//         vinTextBoxOEMLibrary.disabled = true;
//     }
// }

// function hideVINTextboxForOEM() {
//     if (oemVinContainerLibrary && oemVinContainerLibrary.classList.contains("show")) oemVinContainerLibrary.classList.remove("show");
// }

function disableCombinedVariantSelect() {
	if (combinedVariantSelectLibrary)
		combinedVariantSelectLibrary.disabled = true;
}
function clearCombinedVariantSelect() {
	if (combinedVariantSelectLibrary)
		combinedVariantSelectLibrary.selectedIndex = 0;
}

function disablePaintOptionRadioBtns() {
	if (paintOptionCheckboxByUnpainted)
		paintOptionCheckboxByUnpainted.disabled = true;
	if (paintOptionCheckboxByPaintCode) {
		paintOptionCheckboxByPaintCode.disabled = true;
		if (
			paintCodeWrapperLibrary &&
			paintCodeWrapperLibrary.classList.contains("show")
		) {
			paintCodeWrapperLibrary.classList.remove("show");
		}
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLibrary.classList.remove("show");
		}
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLicenseLibrary.classList.remove("show");
		}
	}
	// if (paintOptionCheckboxByVIN) paintOptionCheckboxByVIN.disabled = true;
	// if (paintOptionCheckboxByLicense) paintOptionCheckboxByLicense.disabled = true;
}

function hidePaintCodeWrapper() {
	if (
		paintCodeWrapperLibrary &&
		paintCodeWrapperLibrary.classList.contains("show")
	) {
		paintCodeWrapperLibrary.classList.remove("show");
	}
}

function hidePaintCodeAppContainer(toggleDisplay) {
	// If 'Use VIN' or "Use License Plate" is selected
	if (toggleDisplay) {
		// First check to see if the opposite container is shown (in this case, the license container)
		if (
			paintCodeAppContainerLicenseLibrary &&
			(paintCodeAppContainerLicenseLibrary.style.display === "none" ||
				paintCodeAppContainerLicenseLibrary.style.display === "")
		) {
			// If the license container is shown, hide it (this is to bypass the slide animation)
			paintCodeAppContainerLibrary.style.display = "none";
			paintCodeAppContainerLicenseLibrary.style.display = "block";
			if (
				!paintCodeAppContainerLicenseLibrary.classList.contains("show") &&
				!isLicenseDecoderExhausted
			) {
				paintCodeAppContainerLicenseLibrary.classList.add("show");
			}
		} else {
			// If 'Use Vin' or "Use License Plate" is selected, hide the paint code app container
			if (
				paintCodeAppContainerLibrary &&
				paintCodeAppContainerLibrary.classList.contains("show")
			) {
				paintCodeAppContainerLibrary.classList.remove("show");
			}
		}
	} else {
		// If 'Use VIN' or "Use License Plate" is not selected, remove the 'show' class for the animation
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLibrary.classList.remove("show");
		}

		// Reset the display properties
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.style.display !== ""
		) {
			paintCodeAppContainerLibrary.style.display = "";
		}
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.style.display !== ""
		) {
			paintCodeAppContainerLicenseLibrary.style.display = "";
		}
	}
}

function hidePaintCodeAppContainerLicense(
	toggleDisplay,
	toggleOppositeContainer,
) {
	// If 'Use VIN' or "Use License Plate" is selected
	if (toggleDisplay) {
		// First check to see if the opposite container is shown (in this case, the VIN container)
		if (
			paintCodeAppContainerLibrary &&
			(paintCodeAppContainerLibrary.style.display === "none" ||
				paintCodeAppContainerLibrary.style.display === "")
		) {
			// If the VIN container is shown, hide it (this is to bypass the slide animation)
			paintCodeAppContainerLicenseLibrary.style.display = "none";
			if (toggleOppositeContainer) {
				paintCodeAppContainerLibrary.style.display = "block";
			} else {
				paintCodeAppContainerLibrary.style.display = "none";
			}
			if (
				!paintCodeAppContainerLibrary.classList.contains("show") &&
				!isVinDecoderExhausted
			) {
				paintCodeAppContainerLibrary.classList.add("show");
			}
		} else {
			// If 'Use VIN' or "Use License Plate" is selected, hide the paint code app container license
			if (
				paintCodeAppContainerLicenseLibrary &&
				paintCodeAppContainerLicenseLibrary.classList.contains("show")
			) {
				paintCodeAppContainerLicenseLibrary.classList.remove("show");
			}
		}
	} else {
		// If 'Use VIN' or "Use License Plate" is not selected, remove the 'show' class for the animation
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLicenseLibrary.classList.remove("show");
		}

		// Reset the display properties
		if (
			paintCodeAppContainerLicenseLibrary &&
			paintCodeAppContainerLicenseLibrary.style.display !== ""
		) {
			paintCodeAppContainerLicenseLibrary.style.display = "";
		}
		if (
			paintCodeAppContainerLibrary &&
			paintCodeAppContainerLibrary.style.display !== ""
		) {
			paintCodeAppContainerLibrary.style.display = "";
		}
	}
}

function clearPaintOptionRadioBtns() {
	if (paintOptionsCheckboxGroupLibrary) {
		const radios = document.querySelectorAll(
			`input[name="select_paint_option"]`,
		);
		radios.forEach((radio) => (radio.checked = false));
	}
}

function hidePaintOptionCheckboxGroup() {
	if (
		paintOptionsCheckboxGroupLibrary &&
		paintOptionsCheckboxGroupLibrary.classList.contains("hide")
	) {
		paintOptionsCheckboxGroupLibrary.classList.remove("hide");
	}
}

// function hideGetPaintCodeUsingVINCheckbox() {
//     if (checkboxGetPaintCodeWithVINAndLabel) checkboxGetPaintCodeWithVINAndLabel.style.display = "none";
//     if (checkboxGetPaintCodeWithLicenseAndLabel) checkboxGetPaintCodeWithLicenseAndLabel.style.display = "none";
// }

function hidePaintedStockKeyPaintDisclaimer() {
	if (paintedStockKeyPaintLevelLibrary)
		paintedStockKeyPaintLevelLibrary.style.display = "none";
}

function hidePaintedStockKeyQualityDisclaimer() {
	if (paintedStockKeyQualityLevelLibrary)
		paintedStockKeyQualityLevelLibrary.style.display = "none";
}

function disablePaintedStockKeyQualityDisclaimer() {
	if (paintedStockKeyQualityLevelLibrary)
		paintedStockKeyQualityLevelLibrary.classList.add("disabled");
}

function hideVinMessageParagraph() {
	const vinMessageParagraphLibrary = document.querySelector(
		".vin-decoder-message",
	);

	if (vinMessageParagraphLibrary) {
		vinMessageParagraphLibrary.style.display = "none";
	}
}

function hideLicenseMessageParagraph() {
	const licenseMessageParagraphLibrary = document.querySelector(
		".license-decoder-message",
	);

	if (licenseMessageParagraphLibrary) {
		licenseMessageParagraphLibrary.style.display = "none";
	}
}

function disablehowToFindPaintCodeBtn() {
	disablePaintOptionRadioBtns();
	if (howToFindPaintCodeBtnLibrary)
		howToFindPaintCodeBtnLibrary.disabled = true;
}

function disableGetPaintCodeUsingVin() {
	if (getPaintCodeUsingVinLibrary) getPaintCodeUsingVinLibrary.disabled = true;
}

function hideColorPreviewContainer() {
	if (
		colorPreviewContainerLibrary &&
		colorPreviewContainerLibrary.classList.contains("show")
	)
		colorPreviewContainerLibrary.classList.remove("show");
}

function disableSelectVinVariantBtn() {
	if (selectVinVariantButtonLibrary)
		selectVinVariantButtonLibrary.disabled = true;
}

// function disablePrecisionMatchBtns() {
//     if (precisionMatchCheckboxYes) precisionMatchCheckboxYes.disabled = true;
//     if (precisionMatchCheckboxNo) precisionMatchCheckboxNo.disabled = true;
//     if (precisionMatchButton) precisionMatchButton.disabled = true;
// }

// function clearPrecisionMatchRadioButtons() {
//     if (precisionMatchContainerLibrary) {
//         const radios = document.querySelectorAll(`input[name="precision_match"]`);
//         radios.forEach(radio => radio.checked = false);
//         precisionMatchVinWrapper.classList.remove('show');
//         precisionMatchInputBox.value = '';
//         emptyPrecisionMatchRadioButtons = true;
//     }
// }

function disableVinVerificationBtns() {
	if (vinVerifyCheckbboxYesLibrary)
		vinVerifyCheckbboxYesLibrary.disabled = true;
	if (vinVerifyCheckboxNoLibrary) vinVerifyCheckboxNoLibrary.disabled = true;
	if (vinVerificationButtonLibrary)
		vinVerificationButtonLibrary.disabled = true;
	if (vinVerificationInput) vinVerificationInput.disabled = true;
}

function clearVinVerificationRadioButtons() {
	if (vinVerificationCheckboxGroupLibrary) {
		const radios = document.querySelectorAll(`input[name="fitment_guarantee"]`);
		radios.forEach((radio) => (radio.checked = false));
		vinVerificationWrapper.classList.remove("show");
		// vinVerificationInput.value = '';
		emptyVinVerificationRadioButtons = true;
	}
}

function hideOOSPaintVariantsMsg() {
	const oosPaintVariantsLibrary = document.querySelector(".oos-paint-variants");
	if (
		oosPaintVariantsLibrary &&
		oosPaintVariantsLibrary.classList.contains("show")
	)
		oosPaintVariantsLibrary.classList.remove("show");
}

function hideVinInputAfterSelection() {
	const vinAfterSelectionInput = document.getElementById(
		"vin-after-paint-code-textbox",
	);
	if (vinAfterSelection && vinAfterSelection.classList.contains("show")) {
		vinAfterSelection.classList.remove("show");
	}

	if (vinAfterSelectionInput) {
		vinAfterSelectionInput.required = false;
		vinAfterSelectionInput.value = "";
	}
}

function hideVinInputIfVinExist() {
	const vinAfterSelectionInput = document.getElementById(
		"vin-after-paint-code-textbox",
	);
	const terms = window.getSearchTerms() || [];
	const existingVIN = (terms[0]?.vin || "").trim();
	// Must check to see if there is no existingViN AND if the class 'has-vin-on-file' already exists
	if (!existingVIN && document.body.classList.contains("has-vin-on-file")) {
		document.body.classList.remove("has-vin-on-file");
		return;
	}
	if (!existingVIN) return;

	document.body.classList.add("has-vin-on-file");

	// Make sure the field cannot block form submission
	if (vinAfterSelectionInput) {
		vinAfterSelectionInput.required = false;
		vinAfterSelectionInput.value = existingVIN.toUpperCase(); // optional, if still want it captured as a property
	}
	hideVinInputAfterSelection();
}

function clearOOSPaintCheckbox() {
	const checkbox = document.querySelector(
		`input[name="acknowledge_difficult_paint"]`,
	);
	if (checkbox.checked === true) checkbox.checked = false;
}

function hideFitmentVerificationComponent(isBannedString) {
	const vinGuaranteeContainer = document.querySelector(
		".vin-guarantee-container",
	);
	if (
		vinGuaranteeContainer &&
		!vinGuaranteeContainer.classList.contains("hide")
	) {
		vinGuaranteeContainer.classList.add("hide");
	}
	if (isBannedString !== "") {
		enableOrDisableAddToCartForOEM(isBannedString);
	}
}

function hideVinVerificationTextbox() {
	if (
		vinVerificationWrapper &&
		vinVerificationWrapper.classList.contains("show")
	)
		vinVerificationWrapper.classList.remove("show");
}

// function hideAndClearPrecisionMatchWrapper() {
// 	if (precisionMatchWrapper && precisionMatchWrapper.classList.contains("show"))
// 		precisionMatchWrapper.classList.remove("show");
// 	if (
// 		precisionMatchWrapper &&
// 		precisionMatchWrapper.classList.contains("required")
// 	)
// 		precisionMatchWrapper.classList.remove("required");
// 	if (precisionMatchInputBox) precisionMatchInputBox.value = "";
// }

function hideAddToCartButton() {
	if (currentAddToCartBtnLibrary)
		currentAddToCartBtnLibrary.style.display = "none";
}

function disableAddToCartButton() {
	if (currentAddToCartBtnLibrary) currentAddToCartBtnLibrary.disabled = true;
	if (addToCartStickyLibrary) addToCartStickyLibrary.disabled = true;
}

// ENABLING
function showFitmentFailButton() {
	// Must defined the element here as it is dynamically created
	const fitmentFailButtonLibrary = document.getElementById(
		"fitment-fail-button",
	);

	if (fitmentFailButtonLibrary)
		fitmentFailButtonLibrary.style.display = "block";
}

function enablePrePaintedMessagingQualityLevel() {
	if (paintedStockKeyQualityLevelLibrary) {
		paintedStockKeyQualityLevelLibrary.classList.remove("disabled");
	}
}

function enableProductTypeSelect() {
	if (qualityOptionsCheckboxLibrary) {
		const qualityRadioButtons = document.querySelectorAll(
			'input[name="quality_type"]',
		);

		// If quality options checkboxes
		qualityRadioButtons.forEach((radio) => {
			if (radio.dataset.available === "true") {
				radio.disabled = false;
			}
		});
	}
	if (qualityTypeSelectLibrary) qualityTypeSelectLibrary.disabled = false;
}

function enableQualityDescriptionBtn() {
	if (qualityDescriptionBtnLibrary)
		qualityDescriptionBtnLibrary.disabled = false;
}

function enableFitmentSelect() {
	const fitmentRadioButtons = document.querySelectorAll(".fitment-radio");
	if (fitmentRadioButtons.length > 0) {
		fitmentRadioButtons.forEach((radio) => {
			if (radio) {
				radio.disabled = false;
			}
		});
	}
	const fitmentTexts = document.querySelectorAll(".fitmentText");
	if (fitmentTexts.length > 0) {
		fitmentTexts.forEach(function (el) {
			if (el) {
				el.classList.remove("fitment-disabled");
				el.style.color = "#000";
			}
		});
	}
	const fitmentTypeSelects = document.querySelectorAll(".fitment-type-select");
	if (fitmentTypeSelects.length > 0) {
		fitmentTypeSelects.forEach(function (el) {
			if (el) {
				el.classList.add("fitment-disabled");
			}
		});
	}
	const additionalOptionsTitle = document.querySelector(
		".additional-options-title",
	);
	if (additionalOptionsTitle) {
		additionalOptionsTitle.classList.remove(
			"additional-options-title-disabled",
		);
		additionalOptionsTitle.style.color = "#e61b24";
	}

	if (fitmentDescriptionContainerLibrary) {
		const firstFitmentQuestionButton = document.getElementById(
			"fitment-button-description-0",
		);
		if (firstFitmentQuestionButton) {
			firstFitmentQuestionButton.disabled = false;
		}
	}
}

function showNotCompatibleMsg(groupIndex) {
	const allMsgs = document.querySelectorAll(".not-compatible-msg");
	allMsgs.forEach((el, idx) => {
		// Find the parent group index for each message
		const parent = el.closest(".fitment-type-select");
		if (parent && parent.getAttribute("data-group-index") == groupIndex) {
			el.style.display = "block";
		} else {
			el.style.display = "none";
		}
	});
}

// function enableVINTextboxForOEM() {
//     if (vinTextBoxOEMLibrary) vinTextBoxOEMLibrary.disabled = false;
// }

function enableCombinedVariantSelect() {
	if (combinedVariantSelectLibrary)
		combinedVariantSelectLibrary.disabled = false;
}

function showPaintCodeWrapper() {
	if (
		paintCodeWrapperLibrary &&
		!paintCodeWrapperLibrary.classList.contains("show")
	) {
		paintCodeWrapperLibrary.classList.add("show");
	}
}

function showPaintCodeAppContainer() {
	if (
		paintCodeAppContainerLibrary &&
		!paintCodeAppContainerLibrary.classList.contains("show")
	) {
		if (
			paintCodeAppContainerLicenseLibrary &&
			!paintCodeAppContainerLicenseLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLibrary.classList.add("show");
		} else {
			paintCodeAppContainerLibrary.style.display = "block";
			paintCodeAppContainerLicenseLibrary.style.display = "none";
		}
	}
}

function showPaintCodeAppContainerLicense() {
	if (
		paintCodeAppContainerLicenseLibrary &&
		!paintCodeAppContainerLicenseLibrary.classList.contains("show")
	) {
		if (
			paintCodeAppContainerLibrary &&
			!paintCodeAppContainerLibrary.classList.contains("show")
		) {
			paintCodeAppContainerLicenseLibrary.classList.add("show");
		} else {
			paintCodeAppContainerLicenseLibrary.style.display = "block";
			paintCodeAppContainerLibrary.style.display = "none";
		}
	}
}

function enablePaintOptionRadioBtns() {
	if (paintOptionCheckboxByUnpainted)
		paintOptionCheckboxByUnpainted.disabled = false;
	if (paintOptionCheckboxByPaintCode)
		paintOptionCheckboxByPaintCode.disabled = false;
	// if (paintOptionCheckboxByVIN) paintOptionCheckboxByVIN.disabled = false;
	// if (paintOptionCheckboxByLicense) paintOptionCheckboxByLicense.disabled = false;
}

// function showGetPaintCodeUsingVINCheckbox() {
//     if (checkboxGetPaintCodeWithVINAndLabel) checkboxGetPaintCodeWithVINAndLabel.style.display = "block";
// }

function showPaintedStockKeyPaintDisclaimer() {
	if (paintedStockKeyPaintLevelLibrary)
		paintedStockKeyPaintLevelLibrary.style.display = "block";
}

function showPaintedStockKeyQualityDisclaimer(message) {
	if (paintedStockKeyQualityLevelLibrary) {
		paintedStockKeyQualityLevelLibrary.style.display = "block";
		paintedStockKeyQualityLevelLibrary.innerHTML = message;
	}
}

function enablePaintedStockKeyQualityDisclaimer() {
	if (paintedStockKeyQualityLevelLibrary)
		paintedStockKeyQualityLevelLibrary.classList.remove("disabled");
}

function showVinMessageParagraph() {
	const vinMessageParagraphLibrary = document.querySelector(
		".vin-decoder-message",
	);

	if (vinMessageParagraphLibrary) {
		vinMessageParagraphLibrary.style.display = "block";
	}
}

function showLicenseMessageParagraph() {
	const licenseMessageParagraphLibrary = document.querySelector(
		".license-decoder-message",
	);

	if (licenseMessageParagraphLibrary) {
		licenseMessageParagraphLibrary.style.display = "block";
	}
}

function enablehowToFindPaintCodeBtn() {
	enablePaintOptionRadioBtns();
	if (howToFindPaintCodeBtnLibrary)
		howToFindPaintCodeBtnLibrary.disabled = false;
}

function enableGetPaintCodeUsingVin() {
	if (getPaintCodeUsingVinLibrary) getPaintCodeUsingVinLibrary.disabled = false;
}

function showColorPreviewContainer() {
	if (
		colorPreviewContainerLibrary &&
		!colorPreviewContainerLibrary.classList.contains("show")
	)
		colorPreviewContainerLibrary.classList.add("show");
}

function enableSelectVinVariantBtn() {
	if (selectVinVariantButtonLibrary)
		selectVinVariantButtonLibrary.disabled = false;
}

function enablePrecisionMatchBtns() {
	if (precisionMatchCheckboxYes) precisionMatchCheckboxYes.disabled = false;
	if (precisionMatchCheckboxNo) precisionMatchCheckboxNo.disabled = false;
	if (precisionMatchButton) precisionMatchButton.disabled = false;
}

function enableVinVerificationBtns() {
	if (vinVerifyCheckbboxYesLibrary)
		vinVerifyCheckbboxYesLibrary.disabled = false;
	if (vinVerifyCheckboxNoLibrary) vinVerifyCheckboxNoLibrary.disabled = false;
	if (vinVerificationButtonLibrary)
		vinVerificationButtonLibrary.disabled = false;
	if (!finalVinVerificationSubmissionVin) {
		if (vinVerificationInput) vinVerificationInput.disabled = false;
	}
}

function showOOSPaintVariantsMsg() {
	const oosPaintVariantsLibrary = document.querySelector(".oos-paint-variants");
	if (
		oosPaintVariantsLibrary &&
		!oosPaintVariantsLibrary.classList.contains("show")
	)
		oosPaintVariantsLibrary.classList.add("show");
	// if the add to cart btn is enabled, disable it
	if (currentAddToCartBtnLibrary && !currentAddToCartBtnLibrary.disabled) {
		currentAddToCartBtnLibrary.disabled = true;
	}
}

function showVinInputAfterSelection() {
	if (vinAfterSelection && !vinAfterSelection.classList.contains("show")) {
		vinAfterSelection.classList.add("show");
	}

	// if the add to cart btn is enabled, disable it
	if (currentAddToCartBtnLibrary && !currentAddToCartBtnLibrary.disabled) {
		currentAddToCartBtnLibrary.disabled = true;
	}
}

function showFitmentVerificationComponent() {
	const vinGuaranteeContainer = document.querySelector(
		".vin-guarantee-container",
	);
	if (
		vinGuaranteeContainer &&
		vinGuaranteeContainer.classList.contains("hide")
	) {
		vinGuaranteeContainer.classList.remove("hide");
	}
}

function showVinVerificationTextbox() {
	if (vinVerificationWrapper) vinVerificationWrapper.classList.add("show");
}

// function showPrecisionMatchWrapper() {
// 	if (
// 		precisionMatchWrapper &&
// 		!precisionMatchWrapper.classList.contains("show")
// 	)
// 		precisionMatchWrapper.classList.add("show");
// }

function showAddToCartButton() {
	if (currentAddToCartBtnLibrary)
		currentAddToCartBtnLibrary.style.display = "block";
}

function enableAddToCartButton() {
	if (currentAddToCartBtnLibrary) currentAddToCartBtnLibrary.disabled = false;
	if (addToCartStickyLibrary) addToCartStickyLibrary.disabled = false;
}

// Enable or Disable

// finalVinVerificationSubmissionVin: This is the VIN that is submitted for verification, if it exists.
function enableOrDisableAddToCartForOEM(finalVinVerificationOrBanned) {
	if (!vinDecoderJustUsed) {
		if (
			(selectedProductType === "oem" || isOnlyOEM) &&
			finalVinVerificationOrBanned === ""
		) {
			disableAddToCartButton();
		} else if (
			(selectedProductType === "oem" || isOnlyOEM) &&
			finalVinVerificationOrBanned !== "" &&
			!successfulVinVerificationVin
		) {
			// disable add to cart if vin verification failed three times and OEM has been selected
			disableAddToCartButton();
		} else {
			enableAddToCartButton();
		}
	} else if (
		vinDecoderJustUsed &&
		finalVinVerificationOrBanned === "ISBANNED"
	) {
		disableAddToCartButton();
	} else {
		enableAddToCartButton();
	}
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                         Fitment Questions                                          **
 **                                                                                                    **
 *******************************************************************************************************/

// Utility function to enable or disable a fitment group and update all related classes/styles
function setFitmentGroupState(group, enabled, keyIndex) {
	if (!group) return;
	const optionsContainer = group.querySelector(".fitment-options-container");
	const title = group.querySelector(".option-title-fitment");
	const button = document.getElementById(
		`fitment-button-description-${keyIndex}`,
	);
	if (enabled) {
		group.classList.remove("fitment-disabled");
		if (optionsContainer) optionsContainer.classList.remove("fitment-disabled");
		if (title) title.classList.remove("individual-fitment-title-disabled");
		if (button && Number(keyIndex) !== 0) button.disabled = false;
		group.querySelectorAll(".fitment-option").forEach(function (option) {
			const label = option.querySelector("label");
			if (label) label.classList.remove("individual-fitment-label-disabled");
			const input = option.querySelector('input[type="radio"]');
			if (input) {
				input.classList.remove("individual-fitment-select-disabled");
				input.disabled = false;
			}
		});
	} else {
		group.classList.add("fitment-disabled");
		if (optionsContainer) optionsContainer.classList.add("fitment-disabled");
		if (title) title.classList.add("individual-fitment-title-disabled");
		if (button && Number(keyIndex) !== 0) button.disabled = true;
		group.querySelectorAll(".fitment-option").forEach(function (option) {
			const label = option.querySelector("label");
			if (label) label.classList.add("individual-fitment-label-disabled");
			const input = option.querySelector('input[type="radio"]');
			if (input) {
				input.classList.add("individual-fitment-select-disabled");
				input.disabled = true;
			}
		});
	}
}

async function fetchFitmentQuestionContent(url, currentLocale) {
	if (!url) {
		console.error("No URL provided for fitment key modal content.");
		return;
	}

	if (currentLocale === "es") {
		let parts = url.split(".com/");

		if (parts.length === 2) {
			url = `${parts[0]}.com/es/${parts[1]}`;
		}
	}

	try {
		const response = await fetch(`${url}.json`);
		if (!response.ok) {
			throw new Error("Failed to fetch content");
		}
		const data = await response.json();
		return data.page.body_html; // Assuming the content is in the body_html of the page
	} catch (error) {
		const accordion = document.getElementById("fitment-accordion");
		if (accordion) {
			accordion.style.display = "none";
		}
		console.error("Fetch error:", error);
	}
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                       Quality Options                                              **
 **                                                                                                    **
 *******************************************************************************************************/

function handleQualityLevelPrePaintMsg(
	STOCK_POSTFIX,
	aftermarketWord,
	andWord,
) {
	// Displays the pre-painted in stock message at quality level
	if (window.enablePrepaintedMessaging) {
		if (aftermarketAvailability || capaAvailability || oemAvailability) {
			const options = [];

			if (aftermarketAvailability)
				options.push(`<strong>${aftermarketWord}</strong>`);
			if (capaAvailability) options.push("<strong>CAPA</strong>");
			if (oemAvailability) options.push("<strong>OEM</strong>");

			// Join the list properly with commas and "and"
			let optionsString = "";
			if (options.length === 1) {
				optionsString = options[0];
			} else if (options.length === 2) {
				optionsString = `${options[0]} ${andWord} ${options[1]}`;
			} else if (options.length === 3) {
				optionsString = `${options[0]}, ${options[1]}, ${andWord} ${options[2]}`;
			}

			const finalMessage = `${optionsString} ${STOCK_POSTFIX}`;
			showPaintedStockKeyQualityDisclaimer(finalMessage);
		}
	}
}

function addInStockBadgeInQualityOptions() {
	qualityOptionsLibrary.forEach((button) => {
		const quality = button.getAttribute("data-value");
		const isInStock = handleCheckQualityAvailability(quality);

		if (isInStock) {
			// Create the new element
			const badge = createInStockBadge();

			// Insert before the .quality-option-labels element
			const labels = button.querySelector(".quality-option-labels");
			if (labels) {
				button.insertBefore(badge, labels);
			}
		}
	});
}

function addInStockBadgeInPaintOptions() {
	addedBadgeInPaintOptions = true;
	paintOptionsIndividualButtonsLibrary.forEach((button) => {
		// Create the new element
		const badge = createInStockBadge();
		badge.classList.add("ready-paint");

		// Insert before the .quality-option-labels element
		const labels = button.querySelector(".paint-option-labels-wrapper");
		if (labels) {
			button.insertBefore(badge, labels);
		}
	});
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                         Paint Options                                              **
 **                                                                                                    **
 *******************************************************************************************************/

function togglePaintedStockKey(selectedType, hasAvailableOptions) {
	if (!paintedStockKeyPaintLevelLibrary) return false;

	if (hasAvailableOptions[selectedType]) {
		selectedOptionHasAvailableStock = true;
	} else {
		selectedOptionHasAvailableStock = false;
	}
}

async function populateVariantDropdown(
	selectedType,
	disabledFirstOptionTranslation,
) {
	const combinedVariantSelect = document.getElementById("variant-selector");
	if (combinedVariantSelect) {
		combinedVariantSelect.innerHTML = `<option value="" disabled selected>${disabledFirstOptionTranslation}</option>`;
	}

	if (combinedVariantSelect) {
		clearCombinedVariantSelect(); // Reset to first option (Select Paint Code)
		disableAddToCartButton();
	}

	// Get the relevant variants for selected product type
	// Add defensive checks to ensure productVariants exists
	if (!productVariants || typeof productVariants !== "object") {
		console.warn("productVariants is not initialized");
		return;
	}

	let variants = productVariants[selectedType] || [];

	// Ensure variants is always an array
	if (!Array.isArray(variants) || variants.length === 0) {
		if (productVariants.single && Array.isArray(productVariants.single)) {
			// If no variants for the selected type, use the single variant
			variants = productVariants.single;
		} else if (
			productVariants.current &&
			Array.isArray(productVariants.current)
		) {
			variants = productVariants.current;
		} else {
			// Final fallback to empty array
			variants = [];
		}
	}

	const variantsUpdateEvent = new CustomEvent("variantsUpdated", {
		detail: { variants },
	});
	document.dispatchEvent(variantsUpdateEvent);

	if (Array.isArray(variants) && variants.length > 0) {
		if (combinedVariantSelect) {
			enableCombinedVariantSelect();
			updateProgressHeaderColors();
		}
		enablehowToFindPaintCodeBtn();
		enableGetPaintCodeUsingVin();
		enableSelectVinVariantBtn();

		variants.forEach(function (variant) {
			let isVariantAvailable = true;

			// set it to true in the following because it is actually checking to see if the variant is hidden
			if (
				variant.variantAvailable === "true" ||
				variant.variantAvailable === true
			) {
				isVariantAvailable = false;
			} else {
				isVariantAvailable = true;
			}

			window.selectedVariantId = variant.id;
			let option;

			// Compose base label
			let optionLabel = `${variant.title}`;

			// If it has extra inventory, append the tag to the text
			if (window.enablePrepaintedMessaging) {
				if (variant.hasExtraInventory && isVariantAvailable) {
					optionLabel += " 🚚";
				}
			}

			if (boolMatchByVIN === false) {
				// Check if the variant is "Match Paint by VIN"
				if (
					variant.title.trim().startsWith("Match Paint by VIN") ||
					variant.title.trim().startsWith("Pintura de combinación por VIN")
				) {
					// Create a div instead of an option
					const div = document.createElement("div");
					div.classList.add("hidden-vin-option");

					// Copy attributes to div
					div.setAttribute("data-price", variant.price || "");
					div.setAttribute(
						"data-price-difference",
						variant.priceDifference || "",
					);
					div.setAttribute("data-color", variant.color || "");
					div.setAttribute("data-variant-title", variant.variantTitle || "");
					div.setAttribute("data-product-title", variant.productTitle || "");
					div.setAttribute("data-variant-sku", variant.variantSku || "");

					// Set text content
					div.dataset.value = variant.id || "";
					div.textContent = variant.title;
					div.style.display = "none";

					// Append div after select
					combinedVariantSelect.insertAdjacentElement("afterend", div);
					return;
				} else {
					// Create an option normally
					option = document.createElement("option");
					option.value = variant.id;

					if (!isVariantAvailable) {
						amountOfOOSPaintVariants++;
						option.dataset.unavailable = "true";
					} else {
						option.dataset.unavailable = "false";
					}

					option.textContent = optionLabel;
					option.dataset.price = variant.price;
					option.dataset.color = variant.color;
					option.dataset.variantTitle = variant.variantTitle;
					option.dataset.priceDifference = variant.priceDifference;
					option.dataset.productTitle = variant.productTitle;
					option.dataset.variantSku = variant.variantSku;
				}
			} else {
				option = document.createElement("option");
				option.value = variant.id;

				if (!isVariantAvailable) {
					amountOfOOSPaintVariants++;
					option.dataset.unavailable = "true";
				} else {
					option.dataset.unavailable = "false";
				}

				option.textContent = optionLabel;
				option.dataset.price = variant.price;
				option.dataset.color = variant.color;
				option.dataset.priceDifference = variant.priceDifference;
				option.dataset.productTitle = variant.productTitle;
				option.dataset.variantSku = variant.variantSku;
			}

			if (failedVinDecode === true) {
				option.style.display = "block";
			}

			let currentProductTitle = variant.productTitle || "";
			if (currentProductTitle.length === 0) {
				currentProductTitle = variant.name;
			}

			if (currentProductTitle.length > 0) {
				const productTitle = decodeHtmlEntities(variant.productTitle);
				if (selectedType !== "oem") {
					titleElementLibrary.textContent = productTitle;
				}
			}

			// Optionally add class to selected item or add tooltip
			if (variant.hasExtraInventory) {
				option.dataset.status = "ready-to-ship";
				option.title = "Ready to ship"; // Tooltip when hovering
			}
			const tempElement = document.createElement("div");
			tempElement.innerHTML = variant.productDescription;
			if (productPartDescriptionLibrary) {
				productPartDescriptionLibrary.innerHTML = tempElement.innerHTML;
			}
			if (combinedVariantSelect) {
				combinedVariantSelect.appendChild(option);
			}
		});
	} else {
		if (combinedVariantSelect) {
			disableCombinedVariantSelect();
			clearCombinedVariantSelect();
			disableAddToCartButton();
			updateProgressHeaderColors();
		}
		disablehowToFindPaintCodeBtn();
		disableGetPaintCodeUsingVin();
		disableSelectVinVariantBtn();
	}
}

function decodeHtmlEntities(text) {
	const tempElement = document.createElement("textarea");
	tempElement.innerHTML = text;
	return tempElement.value;
}

// function to check paint code availabilty and toggle VIN input between required and optional
function handlePaintCodeAvailability(
	selectedOption,
	requiredLabelText,
	optionalLabelText,
	isOnlyOEM,
) {
	// If on a product page where not quality options are present but the product itself is OEM, always make VIN required unless
	// it is Unpainted
	// If OEM is selected and the paint option selected is not "Unpainted", always make VIN required
	if (
		(isOnlyOEM && selectedOption.dataset.variantTitle !== "Unpainted") ||
		(selectedProductType === "oem" &&
			selectedOption.dataset.variantTitle !== "Unpainted")
	) {
		selectedVariantUnavailable = true;
	} else {
		selectedVariantUnavailable = selectedOption.dataset.unavailable === "true";
	}

	const optionalSpan = vinAfterSelection.querySelector(
		".vin-after-paint-code-optional",
	);
	const vinAfterSelectionInput = document.getElementById(
		"vin-after-paint-code-textbox",
	);
	// always show the vin input after selection
	showVinInputAfterSelection();
	hideVinInputIfVinExist();

	if (selectedVariantUnavailable) {
		if (vinAfterSelectionInput) {
			vinAfterSelectionInput.required = true;
		}
		if (optionalSpan) {
			optionalSpan.classList.add("required");
			optionalSpan.textContent = requiredLabelText;
		}
	} else {
		// make VIN input optional
		if (vinAfterSelectionInput) {
			vinAfterSelectionInput.required = false;
		}
		if (optionalSpan) {
			optionalSpan.classList.remove("required");
			optionalSpan.textContent = optionalLabelText;
		}
	}
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                         Vin Decoder App                                            **
 **                                                                                                    **
 *******************************************************************************************************/

// function resortToGetPaintCodeByVin(eventVin, eventMatchByVIN) {
//     //Have to get the most up-to-date combined variants
//     const combinedVariantSelect = document.getElementById('variant-selector');
//     const vin = eventVin;
//     let hiddenDiv;
//     storedDecodedVin = vin;

//     if (amountOfVINPostMessages > 0 && eventMatchByVIN === false) {
//         return;
//     }

//     // If boolMatchByVIN is true, then it has already been set in the case that a paint code has been returned for the vin decoder but a matching
//     // option has not been found for it
//     if (boolMatchByVIN === false) {
//         boolMatchByVIN = eventMatchByVIN;
//     }

//     if (document.querySelector('.hidden-vin-option')) {
//         hiddenDiv = document.querySelector('.hidden-vin-option');
//     } else if (document.querySelector('.hidden-vin-option-single-quality')) {
//         hiddenDiv = document.querySelector('.hidden-vin-option-single-quality');
//     }

//     // Only display the option to select Match Paint by VIN in certain circumstances
//     if (boolMatchByVIN) {
//         if (hiddenDiv) {
//             if (!combinedVariantSelect) {
//                 console.error("Error: Select element not found.");
//                 return;
//             }

//             let value;
//             if (hiddenDiv.getAttribute("data-value")) {
//                 value = hiddenDiv.getAttribute("data-value");
//             } else if (hiddenDiv.getAttribute("value")) {
//                 value = hiddenDiv.getAttribute("value");
//             }

//             const text = hiddenDiv.textContent;
//             const price = hiddenDiv.getAttribute("data-price") || "";
//             const priceDifference = hiddenDiv.getAttribute("data-price-difference") || "";
//             const color = hiddenDiv.getAttribute("data-color") || "";
//             const variantTitle = hiddenDiv.getAttribute("data-variant-title") || "";
//             const productTitle = hiddenDiv.getAttribute("data-product-title") || "";
//             const variantSKU = hiddenDiv.getAttribute("data-variant-sku") || "";
//             const option = document.createElement("option");

//             option.value = value;
//             option.textContent = text;
//             option.setAttribute("data-price", price);
//             option.setAttribute("data-price-difference", priceDifference);
//             option.setAttribute("data-color", color);
//             option.setAttribute("data-variant-title", variantTitle);
//             option.setAttribute("data-product-title", productTitle);
//             option.setAttribute("data-variant-sku", variantSKU);

//             option.classList.add("hidden-vin-option");

//             // Append and remove
//             combinedVariantSelect.appendChild(option);
//             hiddenDiv.remove();
//         }
//     }
//     amountOfVINPostMessages++;
// }

/*******************************************************************************************************
 **                                                                                                    **
 **                                             UTILITIES                                              **
 **                                                                                                    **
 *******************************************************************************************************/
function receivedProductVariants(variants) {
	productVariants = variants;
}

function createInStockBadge() {
	const badge = document.createElement("div");
	badge.classList.add("available-options");
	badge.textContent = "✓";
	return badge;
}

function hideInStockBadgeOnPaintOption() {
	if (document.querySelectorAll(".available-options")) {
		const readyBadges = document.querySelectorAll(
			".available-options.ready-paint",
		);
		readyBadges.forEach((badge) => {
			badge.style.display = "none";
		});
	}
}

function showInStockBadgeOnPaintOption() {
	if (document.querySelectorAll(".available-options")) {
		// Check for false prevents from calling the function more than once
		if (addedBadgeInPaintOptions === false) {
			// addInStockBadgeInPaintOptions();
		}
		const readyBadges = document.querySelectorAll(
			".available-options.ready-paint",
		);
		readyBadges.forEach((badge) => {
			badge.style.display = "block";
		});
	}
}

function handleCheckQualityAvailability(quality) {
	let isInStock = false;

	if (quality === "aftermarket" && aftermarketAvailability) {
		isInStock = true;
	} else if (quality === "capa" && capaAvailability) {
		isInStock = true;
	} else if (quality === "oem" && oemAvailability) {
		isInStock = true;
	}
	return isInStock;
}

function addOEMBadge() {
	const capaImg = document.getElementById("capa-certified-badge");
	if (capaImg) capaImg.remove();

	const existingOEMBadge = document.getElementById("oem-badge");
	if (existingOEMBadge) return;

	const oemImg = document.createElement("img");
	oemImg.src =
		"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/OEM_Badge.png";
	oemImg.alt = "OEM Certified";
	oemImg.id = "oem-badge";
	oemImg.style.position = "relative";
	oemImg.style.height = "34px";
	oemImg.style.margin = "0 0 0 10px";

	if (window.innerWidth > 720) {
		priceContainerLargeScreen.appendChild(oemImg);
	} else {
		priceContainerSmallScreen.appendChild(oemImg);
	}
}

function addCAPABadge() {
	const oemImg = document.getElementById("oem-badge");
	if (oemImg) oemImg.remove();

	const existingCapaBadge = document.getElementById("capa-certified-badge");
	if (existingCapaBadge) return;

	const capaImg = document.createElement("img");
	capaImg.src =
		"https://cdn.shopify.com/s/files/1/0248/6291/6693/files/Capa_Certified_Icon_26a22ba1-e72d-4724-a44d-e73fbf1f0d2d.png";
	capaImg.alt = "CAPA Certified";
	capaImg.id = "capa-certified-badge";
	capaImg.style.position = "relative";
	capaImg.style.height = "34px";
	capaImg.style.margin = "0 0 0 10px";

	if (window.innerWidth > 720) {
		priceContainerLargeScreen.appendChild(capaImg);
	} else {
		priceContainerSmallScreen.appendChild(capaImg);
	}
}

function removeBadges() {
	const oemImg = document.getElementById("oem-badge");
	if (oemImg) oemImg.remove();
	const capaImg = document.getElementById("capa-certified-badge");
	if (capaImg) capaImg.remove();
}

function calculatePrice(inputElement) {
	let price;

	if (inputElement.tagName === "SELECT") {
		const selectedOption = inputElement.options[inputElement.selectedIndex];
		price = selectedOption.getAttribute("data-price");
	} else if (inputElement.type === "radio") {
		// Find the checked radio in the group
		const checkedRadio = document.querySelector(
			'input[name="quality_type"]:checked',
		);
		if (!checkedRadio) return;
		price = checkedRadio.getAttribute("data-price");
	} else {
		console.warn("Unsupported element passed to calculatePrice:", inputElement);
		return;
	}

	if (!price) return;

	const formattedPrice = formatPriceToUSD(price);

	document.getElementById("price-display").innerText = formattedPrice;
	document.getElementById("price-display-small-screen").innerText =
		formattedPrice;
	document.getElementById("price-display-sticky").innerText = formattedPrice;
	document.getElementById("price-display-a2c").innerText = formattedPrice;
}

function formatPriceToUSD(price) {
	if (!price) return;

	if (price.trim().startsWith("$")) {
		return price;
	}

	if (price.trim().endsWith("CAD")) {
		const parts = price.trim().split(" ");
		if (parts.length === 2) {
			return "$" + parts[0];
		}
	}

	if (!price.trim().startsWith("$") && !price.trim().endsWith("CAD")) {
		return "$" + price;
	}

	const formattedPrice = (price / 100).toFixed(2);
	return "$" + formattedPrice;
}

function setupVinSync() {
	// consider the VIN input from OEM
	// const vinInputOEM = document.getElementById("vin-textbox-for-oem");
	// push the VIN into add-to-cart form
	// if the car already has the VIN from garage, just skip.
	const vinAfterSelectionInput = document.getElementById(
		"vin-after-paint-code-textbox",
	);

	let searchTerms = getSearchTerms();
	if (searchTerms[0].vin) return;
	// if (activeCar.vin) return;
	const forms = document.querySelectorAll('form[action^="/cart/add"]');
	if (!forms.length) return;
	forms.forEach((form) => {
		// Canonical hidden input
		let main = form.querySelector('input[name="properties[VIN]"]');
		if (!main) {
			main = document.createElement("input");
			main.type = "hidden";
			main.name = "properties[VIN]";
			form.appendChild(main);
		}

		const sync = () => {
			// Get value from the dropdown/selection input (the one that triggered the event)
			const vinAfterSelectionValue = vinAfterSelectionInput.value || "";

			// Get value from the OEM textbox
			// vinInputOEM defined above
			// const vinTextboxValue = vinInputOEM ? vinInputOEM.value : "";

			// use whichever has value
			let finalVin = "";
			if (vinAfterSelectionValue.trim()) {
				finalVin = vinAfterSelectionValue.trim().toUpperCase();
			}

			main.value = finalVin;
			if (finalVin) {
				localStorage.setItem("final car vin", finalVin);
			}

			// push typed vin into localstorage
			searchTerms[0].vin = finalVin;
			setSearchTerms(searchTerms);
			window.GarageLogic.updateGaragePopup(getSearchTerms());
		};
		vinAfterSelectionInput?.addEventListener("input", sync);

		form.addEventListener(
			"submit",
			() => {
				// keep only ONE VIN (uppercase) in the submission
				sync();
				// disable other uppercase duplicates
				form.querySelectorAll('input[name="properties[VIN]"]').forEach((el) => {
					if (el !== main) el.disabled = true;
				});
				// disable legacy 'Vin' so it isn't posted, but leave it in the DOM for any pre-submit code
				form.querySelectorAll('input[name="properties[Vin]"]').forEach((el) => {
					el.disabled = true;
				});
			},
			{ capture: true },
		);
	});
}

/*******************************************************************************************************
 **                                                                                                    **
 **                                             UTILITIES                                              **
 **                                                                                                    **
 *******************************************************************************************************/

function hideShopifyChat() {
	const shopifyChat = document.getElementById("shopify-chat");
	if (shopifyChat) {
		shopifyChat.style.display = "none";
	}
}

function showShopifyChat() {
	const shopifyChat = document.getElementById("shopify-chat");
	if (shopifyChat) {
		shopifyChat.style.display = "block";
	}
}

function evaluateAddToCartButtonState(location) {
	const vinAfterSelectionInput = document.getElementById(
		"vin-after-paint-code-textbox",
	);
	const vinInputValue = (vinAfterSelectionInput?.value || "").toUpperCase();
	const filteredValue = vinInputValue.replace(
		/[IOQ\s:;()!@#$%^?'"&*\-_=+.`~<>{}\[\]|,\/\\]/gi,
		"",
	);
	const isVinValidAndVariantAvailable =
		filteredValue.length === 17 || filteredValue.length === 0;
	const isVinValidAndVariantUnavailable = filteredValue.length === 17;

	const vinAlreadyExists = getSearchTerms()[0]?.vin || "";

	// If there are no variants, and selected product is oem, and vin exists in garage, enable add to cart
	if (
		!combinedVariantSelectLibrary &&
		selectedProductType === "oem" &&
		vinAlreadyExists.length === 17
	) {
		enableAddToCartButton();
		hideVinInputAfterSelection();
		// If there are no variants, and selected product is oem, and vin does not exist in garage, disable add to cart until VIN is typed in
	} else if (
		!combinedVariantSelectLibrary &&
		selectedProductType === "oem" &&
		vinAlreadyExists.length !== 17 &&
		!isVinValidAndVariantUnavailable
	) {
		disableAddToCartButton();
	} else if (isVinValidAndVariantAvailable && !selectedVariantUnavailable) {
		enableAddToCartButton();
		// if vin is valid and variant is unavailable, enable add to cart only if a vin of 17 characters has been entered
	} else if (isVinValidAndVariantUnavailable && selectedVariantUnavailable) {
		enableAddToCartButton();
	} else {
		disableAddToCartButton();
	}
	// Update progress header colors
	updateProgressHeaderColors();
}

/**
 * Auto-selects a single available quality variant when only one option exists
 * Reads data from a hidden div with id="auto-select-variant-data"
 */
function autoSelectSingleQualityVariant() {
	const autoSelectData = document.getElementById("auto-select-variant-data");
	if (!autoSelectData) return;

	const variantId = autoSelectData.getAttribute("data-variant-id");
	const scenario = autoSelectData.getAttribute("data-scenario");

	if (!variantId) {
		console.warn("Auto-select variant data found but no variant ID specified");
		return;
	}

	console.log(`Auto-selecting variant for ${scenario}:`, variantId);

	const form = document.getElementById("product-form");
	if (!form) {
		console.error("Product form not found");
		return;
	}

	// Create or update hidden input for variant ID
	let hiddenInput = document.getElementById("product-form-variant-id");
	if (!hiddenInput) {
		hiddenInput = document.createElement("input");
		hiddenInput.type = "hidden";
		hiddenInput.name = "id";
		hiddenInput.id = "product-form-variant-id";
		form.appendChild(hiddenInput);
	}
	hiddenInput.value = variantId;
	window.selectedVariantId = variantId;

	console.log("Variant ID successfully set to:", hiddenInput.value);
}

// Initialize auto-selection on page load
document.addEventListener("DOMContentLoaded", autoSelectSingleQualityVariant);
